<template>
  <div>
    <el-upload
      action="#"
      :show-file-list="false"
      :http-request="handleUpload"
      accept=".jpg,.png,.jpeg,.svg"
      drag
	  :before-upload="beforeAvatarUpload"
      :on-progress="handleUploadProcess"
    >
      <el-progress
        style="width: 200px"
        :stroke-width="26"
        :text-inside="true"
        :percentage="percent"
        v-if="uploading"
      />
      <div v-if="!uploading" class="imgContainer">
        <img v-if="value" :src="value" class="avatar" />
        <div v-else>
          <i class="el-icon-upload uploader-icon"></i>
          <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
		  <div style="line-height: 18px;">只能上传 jpg/png 文件，且不超过 1MB</div>
        </div>
      </div>
    </el-upload>
  </div>
</template>

<script>
export default {
  props: ["type", "value"],
  watch: {},
  data() {
    return {
      percent: 0,
      uploading: false,
    };
  },
  computed: {
    uploadServer() {
      return `/open/v1/customers/upload`;
    },
  },
  methods: {
	  beforeAvatarUpload(file){
		let size=file.size/(1024*1024)
			if(size>1){
			this.$message({
				message: '图片大小不能超过1M',
				type: 'error'
			})
			return false
			}
	  },
    /**
     * 处理上传文件
     */
    handleUpload(file) {
      const formData = new FormData();
      formData.set("file", file.file);

      this.uploading = true;
      return this.$axios({
        url: `/open/v1/customers/upload`,
        data: formData,
        method: "POST",
        headers: {
          "Content-Type": "multipart/form-data",
        },
        onUploadProgress: (progressEvent) => {
          if (progressEvent.lengthComputable) {
            //计算上传的进度
            this.percent = (
              (progressEvent.loaded / progressEvent.total) *
              100.0
            ).toFixed(0);
          }
        },
      }).then((res) => {
        this.uploading = false;
        this.percent = 0;
        this.$emit("input", res.data.data.url);
      });
    },
    handleUploadProcess(event, file) {
      this.percent = Number(file.percentage.toFixed(0));
    },
  },
};
</script>

<style scoped>
.imgContainer {
  display: flex;
  justify-content: center;
  align-items: center;
  /* border: 1px dashed #d9d9d9; */
  color: #ccc;
  padding: 10px;
}

/* .imgContainer:hover {
  border: 1px dashed #606266;
} */

.imgContainer img {
  max-height: 180px;
}

.uploader-icon {
  font-size: 40px;
}

.el-upload__text {
  font-size: 14px;
}

.loading {
  position: absolute;
  color: #000;
  font-size: 14px;
  display: flex;
  justify-content: center;
  align-items: center;
  display: flex;
}
</style>
